//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid';
import FETCHING from  '../../library/fetching'

 

export default {
    data () {
        return {
          FETCHING : FETCHING,
          token           :localStorage.token,  
          modal_y         :false,
          modal_n         :false,
          terbitkanSurat  :false,

          lihat_blue:false,
          lihat_red:false,
          option_status : [{id  : 0, uraian : 'Proses'}, {id  : 1, uraian : 'Diterima'}, {id  : 2, uraian : 'Dikembalikan'}],
            form: { 
              file_lampiran     :null,
              file_lampiranOld  :null,       
              id:'',
              modul:'lapor_lahir_mati',

              m_provinsi  : '74',
              m_kabupaten : '7405',
              m_kecamatan : '',
              m_desa_kelurahan : '', 
              
              no_kk: '',
              nama: '',
              umur: '',
              pekerjaan: '',
              alamat: '',
              hub_dengan_si_bayi: '',

              // MELAPORKAN BAHWA 
              hari: '',
              tanggal: '',
              pukul: '',
              tempat: '',
              // TELAH LAHIR BAYI 
              jenis_kelamin_bayi: '',
              jenis_lahir:'',
              jenis_lahir_lainnya:'',
              lama_mengandung: '',
              sebab_kematian: '',



              nik_ibu:'',
              nama_ibu:'',
              tgl_lahir_ibu:'',
              pekerjaan_ibu:'',

              provinsi_ibu:'',
              kabupaten_ibu:'',
              kecamatan_ibu:'',
              des_kel_ibu:'',
              alamat_ibu:'',
              kewarganegaraan_ibu:'',
              kewarganegaraan_ibu_lainnya:'',

              tgl_catatan_perkawinan:'',


              nik_ayah:'',
              nama_ayah:'',
              tgl_lahir_ayah:'',
              pekerjaan_ayah:'',

              provinsi_ayah:'',
              kabupaten_ayah:'',
              kecamatan_ayah:'',
              des_kel_ayah:'',
              alamat_ayah:'',
              kewarganegaraan_ayah:'',
              kewarganegaraan_ayah_lainnya:'',

              status : 0,
              keterangan : 0,
              
              keterangan_deskel:'',
              keterangan_kecamatan:'',
              keterangan_kabupaten  :'',

              status_deskel:0,
              status_kecamatan:0,
              status_kabupaten  :0,
              
              createdAt_deskel:'',
              createdAt_kecamatan:'',
              createdAt_kabupaten  :'',               

              file_terbitan   : null,
              emailPemohon    : '',
              email_file      : null,
              email_fileOld   : '',
              email_from      : '',
              email_to        : '',
              email_subject   : '',
              email_html      : '',

              createdBy      : '',

            },


            shape: '', 
            current: 3,  
            dense:true, 
            list_anggota_keluarga:[],
            data: null,

            wilayah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahIbu : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahAyah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
 

            list_data : [],
            list_data_kecamatan : [],
            list_data_kabupaten : [],

            page_limit : 5,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,

            UMUM : UMUM,        
            WILAYAH : WILAYAH,             
        }
    },
    methods: {

      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PELAPORAN_LAHIR_MATI + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                createdBy : this.$store.state.lcProfile.id
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;  
                // console.log(res_data.data);
        });
      },
      validateForm: function() {
        const f = this.form;

        // ========== WILAYAH ADMINISTRASI ==========
        if (!f.m_provinsi || f.m_provinsi === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi wilayah administrasi.' });
          return false;
        }
        if (!f.m_kabupaten || f.m_kabupaten === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten wilayah administrasi.' });
          return false;
        }
        if (!f.m_kecamatan || f.m_kecamatan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan wilayah administrasi.' });
          return false;
        }
        if (!f.m_desa_kelurahan || f.m_desa_kelurahan === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan wilayah administrasi.' });
          return false;
        }

        // ========== YANG BERTANDA TANGAN ==========
        if (!f.no_kk || f.no_kk.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nomor kartu keluarga wajib diisi.' });
          return false;
        }
        if (!f.nama || f.nama.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama pelapor/yang bertanda tangan wajib diisi.' });
          return false;
        }
        if (f.umur === '' || f.umur === null || f.umur === undefined) {
          this.$q.notify({ type: 'negative', message: 'Umur wajib diisi.' });
          return false;
        }
        if (!f.pekerjaan || f.pekerjaan.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Pekerjaan wajib diisi.' });
          return false;
        }
        if (!f.alamat || f.alamat.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat wajib diisi.' });
          return false;
        }
        if (!f.hub_dengan_si_bayi || f.hub_dengan_si_bayi.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Hubungan dengan si bayi wajib diisi.' });
          return false;
        }

        // ========== DATA BAYI ==========
        if (!f.hari || f.hari === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih hari kelahiran bayi.' });
          return false;
        }
        if (!f.tanggal || f.tanggal === '') {
          this.$q.notify({ type: 'negative', message: 'Tanggal kelahiran bayi wajib diisi.' });
          return false;
        }
        if (!f.pukul || f.pukul === '') {
          this.$q.notify({ type: 'negative', message: 'Pukul kelahiran bayi wajib diisi.' });
          return false;
        }
        if (!f.tempat || f.tempat.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Tempat kelahiran bayi wajib diisi.' });
          return false;
        }
        if (!f.jenis_kelamin_bayi || f.jenis_kelamin_bayi === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih jenis kelamin bayi.' });
          return false;
        }
        if (!f.jenis_lahir || f.jenis_lahir === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih jenis kelahiran.' });
          return false;
        }
        if (f.jenis_lahir === 'Lainnya' && (!f.jenis_lahir_lainnya || f.jenis_lahir_lainnya.trim() === '')) {
          this.$q.notify({ type: 'negative', message: 'Isi jenis kelahiran lainnya.' });
          return false;
        }
        if (f.lama_mengandung === '' || f.lama_mengandung === null || f.lama_mengandung === undefined) {
          this.$q.notify({ type: 'negative', message: 'Lama mengandung wajib diisi.' });
          return false;
        }
        if (!f.sebab_kematian || f.sebab_kematian.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Sebab kematian wajib diisi.' });
          return false;
        }

        // ========== DATA IBU ==========
        if (!f.nik_ibu || f.nik_ibu.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'NIK ibu wajib diisi.' });
          return false;
        }
        if (!f.nama_ibu || f.nama_ibu.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama ibu wajib diisi.' });
          return false;
        }
        if (!f.tgl_lahir_ibu || f.tgl_lahir_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Tanggal lahir ibu wajib diisi.' });
          return false;
        }
        if (!f.pekerjaan_ibu || f.pekerjaan_ibu.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Pekerjaan ibu wajib diisi.' });
          return false;
        }
        if (!f.alamat_ibu || f.alamat_ibu.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat ibu wajib diisi.' });
          return false;
        }
        if (!f.kewarganegaraan_ibu || f.kewarganegaraan_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kewarganegaraan ibu.' });
          return false;
        }
        if (f.kewarganegaraan_ibu === 'Lainnya' && (!f.kewarganegaraan_ibu_lainnya || f.kewarganegaraan_ibu_lainnya.trim() === '')) {
          this.$q.notify({ type: 'negative', message: 'Isi kewarganegaraan ibu lainnya.' });
          return false;
        }
        if (!f.tgl_catatan_perkawinan || f.tgl_catatan_perkawinan === '') {
          this.$q.notify({ type: 'negative', message: 'Tanggal pencatatan perkawinan wajib diisi.' });
          return false;
        }
        if (!f.provinsi_ibu || f.provinsi_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi alamat ibu.' });
          return false;
        }
        if (!f.kabupaten_ibu || f.kabupaten_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten alamat ibu.' });
          return false;
        }
        if (!f.kecamatan_ibu || f.kecamatan_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan alamat ibu.' });
          return false;
        }
        if (!f.des_kel_ibu || f.des_kel_ibu === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan alamat ibu.' });
          return false;
        }

        // ========== DATA AYAH ==========
        if (!f.nik_ayah || f.nik_ayah.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'NIK ayah wajib diisi.' });
          return false;
        }
        if (!f.nama_ayah || f.nama_ayah.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Nama ayah wajib diisi.' });
          return false;
        }
        if (!f.tgl_lahir_ayah || f.tgl_lahir_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Tanggal lahir ayah wajib diisi.' });
          return false;
        }
        if (!f.pekerjaan_ayah || f.pekerjaan_ayah.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Pekerjaan ayah wajib diisi.' });
          return false;
        }
        if (!f.alamat_ayah || f.alamat_ayah.toString().trim() === '') {
          this.$q.notify({ type: 'negative', message: 'Alamat ayah wajib diisi.' });
          return false;
        }
        if (!f.kewarganegaraan_ayah || f.kewarganegaraan_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kewarganegaraan ayah.' });
          return false;
        }
        if (f.kewarganegaraan_ayah === 'Lainnya' && (!f.kewarganegaraan_ayah_lainnya || f.kewarganegaraan_ayah_lainnya.trim() === '')) {
          this.$q.notify({ type: 'negative', message: 'Isi kewarganegaraan ayah lainnya.' });
          return false;
        }
        if (!f.provinsi_ayah || f.provinsi_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih provinsi alamat ayah.' });
          return false;
        }
        if (!f.kabupaten_ayah || f.kabupaten_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kabupaten alamat ayah.' });
          return false;
        }
        if (!f.kecamatan_ayah || f.kecamatan_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih kecamatan alamat ayah.' });
          return false;
        }
        if (!f.des_kel_ayah || f.des_kel_ayah === '') {
          this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan alamat ayah.' });
          return false;
        }

        // ========== LAMPIRAN FILE ==========
        if (!f.file_lampiran || f.file_lampiran === '') {
          this.$q.notify({ type: 'negative', message: 'File lampiran wajib diisi.' });
          return false;
        }

        return true;
      },
      add_data(){ 
        // Jalankan validasi sebelum submit
        if (!this.validateForm()) {
          return;
        }

        this.$store.state.modal_loading = true;


        var formData = new FormData(); 
        formData.append("modul", this.form.modul);  

        formData.append("id", uniqid());  

        formData.append("m_provinsi", this.form.m_provinsi);
        formData.append("m_kabupaten", this.form.m_kabupaten);
        formData.append("m_kecamatan", this.form.m_kecamatan);
        formData.append("m_desa_kelurahan", this.form.m_desa_kelurahan); 

        formData.append("no_kk", this.form.no_kk);
        formData.append("nama", this.form.nama);
        formData.append("umur", this.form.umur);
        formData.append("pekerjaan", this.form.pekerjaan);
        formData.append("alamat", this.form.alamat);
        formData.append("hub_dengan_si_bayi", this.form.hub_dengan_si_bayi);
        formData.append("hari", this.form.hari);
        formData.append("tanggal", this.form.tanggal);
        formData.append("pukul", this.form.pukul);
        formData.append("tempat", this.form.tempat);
        formData.append("jenis_kelamin_bayi", this.form.jenis_kelamin_bayi);
        formData.append("jenis_lahir", this.form.jenis_lahir);
        formData.append("jenis_lahir_lainnya", this.form.jenis_lahir_lainnya);
        formData.append("lama_mengandung", this.form.lama_mengandung);
        formData.append("sebab_kematian", this.form.sebab_kematian);

        formData.append("nik_ibu", this.form.nik_ibu);
        formData.append("nama_ibu", this.form.nama_ibu);
        formData.append("tgl_lahir_ibu", this.form.tgl_lahir_ibu);
        formData.append("pekerjaan_ibu", this.form.pekerjaan_ibu);
        formData.append("provinsi_ibu", this.form.provinsi_ibu);
        formData.append("kabupaten_ibu", this.form.kabupaten_ibu);
        formData.append("kecamatan_ibu", this.form.kecamatan_ibu);
        formData.append("des_kel_ibu", this.form.des_kel_ibu);
        formData.append("alamat_ibu", this.form.alamat_ibu);
        formData.append("kewarganegaraan_ibu", this.form.kewarganegaraan_ibu);
        formData.append("kewarganegaraan_ibu_lainnya", this.form.kewarganegaraan_ibu_lainnya);
        formData.append("tgl_catatan_perkawinan", this.form.tgl_catatan_perkawinan);


        formData.append("nik_ayah", this.form.nik_ayah);
        formData.append("nama_ayah", this.form.nama_ayah);
        formData.append("tgl_lahir_ayah", this.form.tgl_lahir_ayah);
        formData.append("pekerjaan_ayah", this.form.pekerjaan_ayah);
        formData.append("provinsi_ayah", this.form.provinsi_ayah);
        formData.append("kabupaten_ayah", this.form.kabupaten_ayah);
        formData.append("kecamatan_ayah", this.form.kecamatan_ayah);
        formData.append("des_kel_ayah", this.form.des_kel_ayah);
        formData.append("alamat_ayah", this.form.alamat_ayah);
        formData.append("kewarganegaraan_ayah", this.form.kewarganegaraan_ayah);
        formData.append("kewarganegaraan_ayah_lainnya", this.form.kewarganegaraan_ayah_lainnya);



        formData.append("keterangan_deskel", this.form.keterangan_deskel);
        formData.append("keterangan_kecamatan", this.form.keterangan_kecamatan);
        formData.append("keterangan_kabupaten", this.form.keterangan_kabupaten);
        
        formData.append("status", this.form.status);
        formData.append("keterangan", this.form.keterangan);
        formData.append("file_lampiran", this.form.file_lampiran);
    

        formData.append("createdAt", UMUM.NOW()); 
        formData.append("emailPemohon", this.form.emailPemohon);


        fetch(this.$store.state.url.URL_PELAPORAN_LAHIR_MATI + "addData", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            }, 
            body: formData 
        }).then(res_data => { 
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_berhasil')
            this.getView();
            // console.log(res_data);
        });
        
      },
      editData : function(){

        this.$store.state.modal_loading = true;


        var formData = new FormData();

        formData.append("id", this.form.id);

        formData.append("m_provinsi", this.form.m_provinsi);
        formData.append("m_kabupaten", this.form.m_kabupaten);
        formData.append("m_kecamatan", this.form.m_kecamatan);
        formData.append("m_desa_kelurahan", this.form.m_desa_kelurahan); 

        formData.append("no_kk", this.form.no_kk);
        formData.append("nama", this.form.nama);
        formData.append("umur", this.form.umur);
        formData.append("pekerjaan", this.form.pekerjaan);
        formData.append("alamat", this.form.alamat);
        formData.append("hub_dengan_si_bayi", this.form.hub_dengan_si_bayi);
        formData.append("hari", this.form.hari);
        formData.append("tanggal", this.form.tanggal);
        formData.append("pukul", this.form.pukul);
        formData.append("tempat", this.form.tempat);
        formData.append("jenis_kelamin_bayi", this.form.jenis_kelamin_bayi);
        formData.append("jenis_lahir", this.form.jenis_lahir);
        formData.append("jenis_lahir_lainnya", this.form.jenis_lahir_lainnya);
        formData.append("lama_mengandung", this.form.lama_mengandung);
        formData.append("sebab_kematian", this.form.sebab_kematian);

        formData.append("nik_ibu", this.form.nik_ibu);
        formData.append("nama_ibu", this.form.nama_ibu);
        formData.append("tgl_lahir_ibu", this.form.tgl_lahir_ibu);
        formData.append("pekerjaan_ibu", this.form.pekerjaan_ibu);
        formData.append("provinsi_ibu", this.form.provinsi_ibu);
        formData.append("kabupaten_ibu", this.form.kabupaten_ibu);
        formData.append("kecamatan_ibu", this.form.kecamatan_ibu);
        formData.append("des_kel_ibu", this.form.des_kel_ibu);
        formData.append("alamat_ibu", this.form.alamat_ibu);
        formData.append("kewarganegaraan_ibu", this.form.kewarganegaraan_ibu);
        formData.append("kewarganegaraan_ibu_lainnya", this.form.kewarganegaraan_ibu_lainnya);
        formData.append("tgl_catatan_perkawinan", this.form.tgl_catatan_perkawinan);


        formData.append("nik_ayah", this.form.nik_ayah);
        formData.append("nama_ayah", this.form.nama_ayah);
        formData.append("tgl_lahir_ayah", this.form.tgl_lahir_ayah);
        formData.append("pekerjaan_ayah", this.form.pekerjaan_ayah);
        formData.append("provinsi_ayah", this.form.provinsi_ayah);
        formData.append("kabupaten_ayah", this.form.kabupaten_ayah);
        formData.append("kecamatan_ayah", this.form.kecamatan_ayah);
        formData.append("des_kel_ayah", this.form.des_kel_ayah);
        formData.append("alamat_ayah", this.form.alamat_ayah);
        formData.append("kewarganegaraan_ayah", this.form.kewarganegaraan_ayah);
        formData.append("kewarganegaraan_ayah_lainnya", this.form.kewarganegaraan_ayah_lainnya);



        formData.append("keterangan_deskel", this.form.keterangan_deskel);
        formData.append("keterangan_kecamatan", this.form.keterangan_kecamatan);
        formData.append("keterangan_kabupaten", this.form.keterangan_kabupaten);
        
        formData.append("status", this.form.status);
        formData.append("keterangan", this.form.keterangan);
        formData.append("file_lampiran", this.form.file_lampiran);
     

        formData.append("fileOld", this.fileOld);


        fetch(this.$store.state.url.URL_PELAPORAN_LAHIR_MATI + "editData", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            // this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.$store.commit('notif_edit');
            this.getView();
        });
      },
      removeData : function(E){
        this.$store.state.modal_loading = true;

        fetch(this.$store.state.url.URL_PELAPORAN_LAHIR_MATI + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                fileOld : this.fileOld,
                file_lampiran : this.form.file_lampiran,
                file_lampiranOld : this.form.file_lampiranOld,
     
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        }); 
      }, 
      selectData:function(data){
        console.log(data);

        this.form.id                            = data.pelaporan_LAHIR_MATI.id
        this.form.m_provinsi                    = data.pelaporan_LAHIR_MATI.m_provinsi
        this.form.m_kabupaten                   = data.pelaporan_LAHIR_MATI.m_kabupaten
        this.form.m_kecamatan                   = data.pelaporan_LAHIR_MATI.m_kecamatan
        this.form.m_desa_kelurahan              = data.pelaporan_LAHIR_MATI.m_desa_kelurahan
        this.form.no_kk                         = data.pelaporan_LAHIR_MATI.no_kk
        this.form.nama                          = data.pelaporan_LAHIR_MATI.nama
        this.form.umur                          = data.pelaporan_LAHIR_MATI.umur
        this.form.pekerjaan                     = data.pelaporan_LAHIR_MATI.pekerjaan
        this.form.alamat                        = data.pelaporan_LAHIR_MATI.alamat
        this.form.hub_dengan_si_bayi            = data.pelaporan_LAHIR_MATI.hub_dengan_si_bayi
        this.form.hari                          = data.pelaporan_LAHIR_MATI.hari
        this.form.tanggal                       = data.pelaporan_LAHIR_MATI.tanggal
        this.form.pukul                         = data.pelaporan_LAHIR_MATI.pukul
        this.form.tempat                        = data.pelaporan_LAHIR_MATI.tempat
        this.form.jenis_kelamin_bayi            = data.pelaporan_LAHIR_MATI.jenis_kelamin_bayi
        this.form.jenis_lahir                   = data.pelaporan_LAHIR_MATI.jenis_lahir
        this.form.jenis_lahir_lainnya           = data.pelaporan_LAHIR_MATI.jenis_lahir_lainnya
        this.form.lama_mengandung               = data.pelaporan_LAHIR_MATI.lama_mengandung
        this.form.sebab_kematian                = data.pelaporan_LAHIR_MATI.sebab_kematian
        this.form.nik_ibu                       = data.pelaporan_LAHIR_MATI.nik_ibu
        this.form.nama_ibu                      = data.pelaporan_LAHIR_MATI.nama_ibu
        this.form.tgl_lahir_ibu                 = data.pelaporan_LAHIR_MATI.tgl_lahir_ibu
        this.form.pekerjaan_ibu                 = data.pelaporan_LAHIR_MATI.pekerjaan_ibu
        this.form.provinsi_ibu                  = data.pelaporan_LAHIR_MATI.provinsi_ibu
        this.form.kabupaten_ibu                 = data.pelaporan_LAHIR_MATI.kabupaten_ibu
        this.form.kecamatan_ibu                 = data.pelaporan_LAHIR_MATI.kecamatan_ibu
        this.form.des_kel_ibu                   = data.pelaporan_LAHIR_MATI.des_kel_ibu
        this.form.alamat_ibu                    = data.pelaporan_LAHIR_MATI.alamat_ibu
        this.form.kewarganegaraan_ibu           = data.pelaporan_LAHIR_MATI.kewarganegaraan_ibu
        this.form.kewarganegaraan_ibu_lainnya   = data.pelaporan_LAHIR_MATI.kewarganegaraan_ibu_lainnya
        this.form.tgl_catatan_perkawinan        = data.pelaporan_LAHIR_MATI.tgl_catatan_perkawinan
        this.form.nik_ayah                      = data.pelaporan_LAHIR_MATI.nik_ayah
        this.form.nama_ayah                     = data.pelaporan_LAHIR_MATI.nama_ayah
        this.form.tgl_lahir_ayah                = data.pelaporan_LAHIR_MATI.tgl_lahir_ayah
        this.form.pekerjaan_ayah                = data.pelaporan_LAHIR_MATI.pekerjaan_ayah
        this.form.provinsi_ayah                 = data.pelaporan_LAHIR_MATI.provinsi_ayah
        this.form.kabupaten_ayah                = data.pelaporan_LAHIR_MATI.kabupaten_ayah
        this.form.kecamatan_ayah                = data.pelaporan_LAHIR_MATI.kecamatan_ayah
        this.form.des_kel_ayah                  = data.pelaporan_LAHIR_MATI.des_kel_ayah
        this.form.alamat_ayah                   = data.pelaporan_LAHIR_MATI.alamat_ayah
        this.form.kewarganegaraan_ayah          = data.pelaporan_LAHIR_MATI.kewarganegaraan_ayah
        this.form.kewarganegaraan_ayah_lainnya  = data.pelaporan_LAHIR_MATI.kewarganegaraan_ayah_lainnya

 

        this.form.status                        = data.pelaporan_LAHIR_MATI.status
        this.form.keterangan                    = data.pelaporan_LAHIR_MATI.keterangan
        this.form.keterangan_deskel             = data.pelaporan_LAHIR_MATI.keterangan_deskel
        this.form.keterangan_kecamatan          = data.pelaporan_LAHIR_MATI.keterangan_kecamatan
        this.form.keterangan_kabupaten          = data.pelaporan_LAHIR_MATI.keterangan_kabupaten
        this.form.status_deskel                 = data.pelaporan_LAHIR_MATI.status_deskel
        this.form.status_kecamatan              = data.pelaporan_LAHIR_MATI.status_kecamatan
        this.form.status_kabupaten              = data.pelaporan_LAHIR_MATI.status_kabupaten
        this.form.createdAt_deskel              = data.pelaporan_LAHIR_MATI.createdAt_deskel
        this.form.createdAt_kecamatan           = data.pelaporan_LAHIR_MATI.createdAt_kecamatan
        this.form.createdAt_kabupaten           = data.pelaporan_LAHIR_MATI.createdAt_kabupaten

        this.form.file_lampiran           = data.pelaporan_LAHIR_MATI.file_lampiran
        this.form.file_lampiranOld           = data.pelaporan_LAHIR_MATI.file_lampiranOld

        this.form.createdBy           = data.pelaporan_LAHIR_MATI.createdBy
        


        this.form.emailPemohon  = data.pelaporan_LAHIR_MATI.emailPemohon;
        this.form.email_fileOld = data.pelaporan_LAHIR_MATI.email_file;
        this.form.email_from    = this.form.email_from;
        this.form.email_to      = this.form.emailPemohon;
        this.form.email_subject = data.pelaporan_LAHIR_MATI.email_subject;
        if (data.pelaporan_LAHIR_MATI.email_html == undefined || data.pelaporan_LAHIR_MATI.email_html == null || data.pelaporan_LAHIR_MATI.email_html == '') {
          this.form.email_html    = ''
        } else {
          this.form.email_html    = data.pelaporan_LAHIR_MATI.email_html; 
        }

        this.wilayah = {
          uraian_provinsi        : data.m_provinsi.uraian,
          kd_provinsi            : data.m_provinsi.kd_provinsi,
          uraian_kabupaten       : data.m_kabupaten.uraian,
          kd_kabupaten           : data.m_kabupaten.kd_kabupaten,
          uraian_kecamatan       : data.m_kecamatan.uraian,
          kd_kecamatan           : data.m_kecamatan.kd_kecamatan,
          uraian_desa_kelurahan  : data.m_desa_kelurahan.uraian,
          kd_desa_kelurahan      : data.m_desa_kelurahan.kd_desa_kelurahan,
        }; 
        this.wilayahIbu = {
          uraian_provinsi       : data.wilayah_provinsi_ibu.uraian,
          kd_provinsi           : data.wilayah_provinsi_ibu.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_ibu.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_ibu.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_ibu.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_ibu.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_ibu.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_ibu.kd_desa_kelurahan,
        }; 
        this.wilayahAyah = {
          uraian_provinsi       : data.wilayah_provinsi_ayah.uraian,
          kd_provinsi           : data.wilayah_provinsi_ayah.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_ayah.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_ayah.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_ayah.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_ayah.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_ayah.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_ayah.kd_desa_kelurahan,
        }; 

      },
      
      clearData : function(){

        this.form = {}
        this.wilayah = {}
        this.wilayahIbu = {}
        this.wilayahAyah = {}
        this.form.file_lampiran = null
        this.form.file_lampiranOld = null

      },

    // ============================= KECAMATAN =============================
      getViewKecamatan : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PELAPORAN_LAHIR_MATI + "viewKecamatan", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                status_kecamatan : this.form.status_kecamatan,
                pl_provinsi       :this.$store.state.lcProfile.provinsi,
                pl_kabupaten      :this.$store.state.lcProfile.kabupaten,
                pl_kecamatan      :this.$store.state.lcProfile.kecamatan,
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data_kecamatan = res_data.data;
                this.page_last = res_data.jmlData; 
                // console.log("INI KECAMATAN")
                console.log(res_data);
        });
      }, 

      editDataKecamatan : function(status){
        this.$store.state.modal_loading = true;

        // console.log(status)
        fetch(this.$store.state.url.URL_PELAPORAN_LAHIR_MATI + "editDataKecamatan", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id : this.form.id,
              keterangan_kecamatan : this.form.keterangan_kecamatan,
              createdAt_kecamatan : UMUM.NOW(),
              kategorix : status
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getViewKecamatan();
        });
      },

    // ============================= KECAMATAN =============================

    // ============================= KABUPATEN =============================
      getViewKabupaten : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PELAPORAN_LAHIR_MATI + "viewKabupaten", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                status_kabupaten : this.form.status_kabupaten
            })
          })
            .then(res => res.json())
            .then(res_data => {
              // console.log("TAAAAAAAAAAIIIIIIII")
                this.list_data_kabupaten = res_data.data;
                this.page_last = res_data.jmlData;
                // this.$store.commit("hideLoading");
                console.log(res_data);
        });
      },
      editDataKabupaten : function(status){
        this.$store.state.modal_loading = true;

        console.log("SA DI CLICK")
        fetch(this.$store.state.url.URL_PELAPORAN_LAHIR_MATI + "editDataKabupaten", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id : this.form.id,
              keterangan_kabupaten : this.form.keterangan_kabupaten,
              createdAt_kabupaten : UMUM.NOW(),
              kategorix : status
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getViewKabupaten();
        });
      },
      terbit_file_Kabupaten : function(){
        this.$store.state.modal_loading = true;

        console.log(this.form.email_fileOld);
        var formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("email_file", this.form.email_file); 
        formData.append("email_fileOld", this.form.email_fileOld); 
        formData.append("email_from", this.form.email_from)
        formData.append("email_to", this.form.email_to)
        formData.append("email_subject", this.form.email_subject) 
        formData.append("email_html", this.form.email_html)
        

        fetch(this.$store.state.url.URL_PELAPORAN_LAHIR_MATI + "file_terbitan_Kabupaten", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData,
        }).then(res_data => { 
            this.wa_notif()
            this.$store.state.modal_loading = false; 
            this.$store.commit('notif_terbit');
            this.getView();
        });
      },
      async wa_notif(){
          var data = await this.FETCHING.fetch_postx(this.$store.state.url.URL_WA_API+'send_wa' , JSON.stringify({
            createdBy : this.form.createdBy,
            pesan     : 'Pelaporan Lahir Mati'
          }))
          console.log(data);
      },
    // ============================= KABUPATEN =============================

      bukaTab(linknya){
        window.open(linknya);
      },
    // ====================================== filter autocomplete ======================================
        renderChildProv(data) {
            return `
            <span><b>${data.kd_provinsi}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChildKab(data) {
            return `
            <span><b>${data.kd_kabupaten}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChildKec(data) {
            return `
            <span><b>${data.kd_kecamatan}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChild_des_kel(data) {
            return `
            <span><b>${data.kd_desa_kelurahan}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        get_auto(data){ 
          this.form.m_provinsi = data.m_provinsi  
        },

        get_auto_kab(data){ 
          this.form.m_kabupaten = data.m_kabupaten  
        },

        get_auto_kec(data){ 
          this.form.m_kecamatan = data.m_kecamatan  
        },

        get_auto_des_kel(data){ 
          this.form.m_desa_kelurahan = data.m_desa_kelurahan 
        },        
 
        prov_ibu(data){  
          this.form.provinsi_ibu = data.m_provinsi  
        }, 
        kab_ibu(data){ 
          this.form.kabupaten_ibu = data.m_kabupaten 
        }, 
        kec_ibu(data){ 
          this.form.kecamatan_ibu = data.m_kecamatan  
        }, 
        des_kel_ibu(data){ 
          this.form.des_kel_ibu = data.m_desa_kelurahan  
        },    

        prov_ayah(data){ 
          this.form.provinsi_ayah = data.m_provinsi  
        },
        kab_ayah(data){ 
          this.form.kabupaten_ayah = data.m_kabupaten 
        },
        kec_ayah(data){ 
          this.form.kecamatan_ayah = data.m_kecamatan  
        },
        des_kel_ayah(data){ 
          this.form.des_kel_ayah = data.m_desa_kelurahan  
        },

        prov_pelapor(data){ 
          this.form.provinsi_pelapor = data.m_provinsi  
        }, 
        kab_pelapor(data){ 
          this.form.kabupaten_pelapor = data.m_kabupaten 
        },
        kec_pelapor(data){ 
          this.form.kecamatan_pelapor = data.m_kecamatan  
        },
        des_kel_pelapor(data){ 
          this.form.des_kel_pelapor = data.m_desa_kelurahan  
        },

        prov_saksi1(data){ 
          this.form.provinsi_saksi1 = data.m_provinsi  
        },
        kab_saksi1(data){ 
          this.form.kabupaten_saksi1 = data.m_kabupaten 
        },
        kec_saksi1(data){ 
          this.form.kecamatan_saksi1 = data.m_kecamatan  
        },
        des_kel_saksi1(data){ 
          this.form.des_kel_saksi1 = data.m_desa_kelurahan  
        },

        prov_saksi2(data){ 
          this.form.provinsi_saksi2 = data.m_provinsi  
        },
        kab_saksi2(data){ 
          this.form.kabupaten_saksi2 = data.m_kabupaten 
        },
        kec_saksi2(data){ 
          this.form.kecamatan_saksi2 = data.m_kecamatan  
        },
        des_kel_saksi2(data){ 
          this.form.des_kel_saksi2 = data.m_desa_kelurahan  
        },
    // ====================================== filter autocomplete ======================================
    
 
      CariData(){
        
        if (this.$store.state.lcProfile.kelas == 'kecamatan') {
          this.getViewKecamatan()
        } else if (this.$store.state.lcProfile.kelas == 'kabupaten') {
          this.getViewKabupaten() 
        }else{
          this.getView();
        } 
      },
 

      cekButton_status_kecamatan: function(data){  
          var a = data.pelaporan_LAHIR_MATI.status 
          var status_kab = data.pelaporan_LAHIR_MATI.status_kabupaten  
          if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
            if (status_kab == 1) {
              return true
            }
            return false
          }else{
            if (a == 1) {
              return true
            }else{
              return false
            }
          }  
        },
          
    },
    mounted(){ 
      this.CariData();
      this.getView();
 
      this.$store.state.lcProfile.kelas
      this.$store.state.lcProfile.id
      var email_from          = this.$store.state.lcProfile.email 
      var email_pemohon       = this.$store.state.lcProfile.email 
      this.form.emailPemohon  = email_pemohon
      this.form.email_from    = email_from 
      

    }
}
